import React, { createContext, useContext, useEffect } from "react";
import { useGetUsers } from "../hooks/useGetUsers";
import { useAuth } from "./AuthContext.js";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const {
    users,
    loading,
    error,
    createUserList: refetch, // renommé pour plus de clarté dans le contexte
  } = useGetUsers();
  const { isConnected } = useAuth();

  useEffect(() => {
    refetch();
  }, [isConnected])

  const tableauInitiales = (users || []).map(user => {
    const id = user.id ?? user.idUtilisateur;
    const initiales = `${(user.surname ?? user.prenom ?? '')?.[0] ?? ''}${(user.name ?? user.nom ?? '')?.[0] ?? ''}`.toUpperCase();
    return { id, initiales };
  });

  return (
    <UserContext.Provider value={{ tableauInitiales, loading, error, refetch }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => useContext(UserContext);
